import * as React from 'react';
import { useParams } from 'react-router-dom';

import EmptyInsight from '@/pages/EmptyInsight';

const InsightIndex: React.FC = () => {
  const { insightId } = useParams();

  if (!insightId) {
    return <EmptyInsight />;
  }

  return null;
};

export default InsightIndex;
